import { render, staticRenderFns } from "./BiometryIntroSheet.vue?vue&type=template&id=6141b0c4&scoped=true&"
import script from "./BiometryIntroSheet.vue?vue&type=script&lang=js&"
export * from "./BiometryIntroSheet.vue?vue&type=script&lang=js&"
import style0 from "./BiometryIntroSheet.vue?vue&type=style&index=0&id=6141b0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141b0c4",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
